import { createSelector } from 'reselect';

export const selectReportsTableTotal = (state) => state.reportsTable.total;
export const selectReportsTableIsLoading = (state) => state.reportsTable.isLoading;
const selectReportsTable = (state) => state.reportsTable;
export const selectUserContext = (state) => state.userContext;
const selectReports = (state) => state.reports;
export const selectDataSource = (state) => state.reportDetails.dataSourceModal;

const getTablePage = (
  total /*: number */,
  deleteSize /*: number */,
  page /*: number */,
  pageSize /*: number */,
) => {
  const lastPage = Math.ceil((total - deleteSize) / pageSize);
  return page > lastPage ? lastPage : page;
};

export const selectTablePageNumber = createSelector(selectReportsTable, (reportsTable) =>
  getTablePage(
    reportsTable.total,
    reportsTable.selectedReports.length,
    reportsTable.tableConfig.page,
    reportsTable.tableConfig.pageSize,
  ),
);

export const selectReportTableData = createSelector(
  [selectReportsTable, selectReports],
  (reportTable, reports) => reportTable?.data?.map((id) => reports[id]) || [],
);

export const selectReportTableHeaders = createSelector(
  [selectReportsTable],
  (reportTable) => reportTable.headers,
);

export const selectReportsTableConfig = createSelector(
  [selectReportsTable],
  (reportTable) => reportTable.tableConfig,
);

export const selectOpenReportsTableModal = createSelector(
  [selectReportsTable],
  (reportsTable) => reportsTable.openReportsTableModal,
);

export const selectDeleteReportData = createSelector(
  [selectReportsTable, selectReports],
  (reportsTable, reports) =>
    reports[reportsTable.deleteReportId]
      ? {
          reportId: reportsTable.deleteReportId,
          reportName: reports[reportsTable.deleteReportId].name,
        }
      : {},
);

export const selectSelectedReports = createSelector(
  [selectReportsTable],
  (reportsTable) => reportsTable.selectedReports,
);
